//task :  https://www.notion.so/cognni/Partners-Portal-Metrics-Datasource-ab8ab64b28ad4ae49400740120dc7735
import axios from "axios";
import { env } from "./env";
import { state } from "./state";

interface AnalyticsEvent {
  // organization unique identifier
  orgId: string;
  // user email address
  email: string;
  // event unique name
  eventId: string;
  // event time (ISO)
  eventTime: string;
  // array of unique tag names
  tags: string[];
  // simple object contains additional properties
  data: { [key: string]: any };
}

function getTokenData(token: string): { [key: string]: string } {
  if (!token) {
    return {};
  }
  try {
    const obj = atob(token.split(".")[1]);
    const data = JSON.parse(obj);
    return data;
  } catch (e) {
    console.log("getTokenData() , error parsing token : ", e);
    return {};
  }
}

const filterOutEmptyVals = (obj: any) => {
  return Object.entries(obj).reduce((acc, [key, val]) => {
    if (val) {
      acc[key] = val;
    }
    return acc;
  }, {} as { [key: string]: any });
};

export const AppAnalytics = (() => {
  let ip = "";
  async function getUserIp() {
    if (!ip) {
      const res = await axios.get("https://api.ipify.org?format=json");
      ip = res.data.ip;
    }
    console.log("ip :", ip);
    return ip;
  }

  getUserIp().then(() => {
    // init ip
  });

  const report = async (p: {
    eventName: string;
    token?: string;
    extra?: Record<string, string | number | boolean>;
  }) => {
    const { eventName, extra = Object.create(null), token = "" } = p;
    try {
      const ipAddress = await getUserIp();
      const { api } = await env();
      const tokenData = getTokenData(token);

      axios({
        method: "POST",
        baseURL: api,
        url: "/analytic/events/onboarding",
        data: {
          partnerId: state.partnerId() || "cognni",
          email: state.email(),
          name: state.name(),
          orgId: tokenData.org || tokenData.orgId,
          eventId: eventName,
          tags: [],
          data: filterOutEmptyVals({
            ipAddress,
            uid: tokenData.uid,
            ...extra,
          }),
        },
        headers: {
          Authorization:
            "Basic NWM4MDE2NTItZjZhOS00NjdlLTk5NjgtNmZmNjUxMWRlYWEyOiYxPGhiXVZCYHZVTypgRHo8bXQrWWsrJjc5VGxZWWQwJD0qb0JmaUktZXpXUFRbNEAxaG5oR2RfJ1VeIUtOWg==",
        },
      });
    } catch (error) {
      console.log("error sending analytics");
    }
  };

  return {
    report,
  };
})();
